import * as React from 'react';
import { Stack, Text } from '@doordash/design-language';
import { useDVSNumber } from '@doordash/lib-dvs-client/lib/react';
import { AdminPageSubpageContentContainer } from '../AdminPage/AdminPageStyles';
import { CreateBudgetPlaceOrder } from './CreateBudgetPlaceOrder';
import { PlaceOrderStrings } from './PlaceOrderStrings';
import { getSelectedTeamAccount } from '../../selectors/uiSelector';
import { useSelector } from 'react-redux';
import { getTeamMemberEmail } from '../../selectors/portal_selector';
import { EXTERNAL_ROUTES } from '../../constants/values';
import { dv2DefaultsNonBoolean, DV2_NAMES } from '../DV2';
import { NonEmPlaceOrder } from './NonEmPlaceOrder';
var strings = PlaceOrderStrings;
export var PlaceOrderContainer = function () {
    var placeOrderVersion = useDVSNumber(DV2_NAMES.ddfwAllowCreateBudgetPlaceOrder, dv2DefaultsNonBoolean.ddfwAllowCreateBudgetPlaceOrder);
    var isPlaceOrderAtTopEnabled = placeOrderVersion === 1;
    var isPlaceOrderAtBottomEnabled = placeOrderVersion === 2;
    var teamAccountId = useSelector(getSelectedTeamAccount);
    var teamMemberEmail = useSelector(getTeamMemberEmail);
    var redirectToMarketplace = function () {
        // open marketplace in new tab
        window.open(EXTERNAL_ROUTES.MARKETPLACE, '_blank');
    };
    if (!isPlaceOrderAtTopEnabled && !isPlaceOrderAtBottomEnabled) {
        // if none of the place order version are enabled
        // do not show feature for admin who are not allowed
        return null;
    }
    return (React.createElement(AdminPageSubpageContentContainer, null,
        React.createElement(Stack, null,
            React.createElement(Text, { styles: Text.Styles.Title1, children: strings.title() })),
        isPlaceOrderAtTopEnabled && (React.createElement(CreateBudgetPlaceOrder, { teamAccountId: teamAccountId, teamMemberEmail: teamMemberEmail, onCreateBudgetSuccess: redirectToMarketplace })),
        isPlaceOrderAtBottomEnabled && (React.createElement(NonEmPlaceOrder, { teamAccountId: teamAccountId, onStartOrderClick: redirectToMarketplace }))));
};
